import React, { useState } from "react";
import styled from "styled-components";
import { FaChevronDown } from "react-icons/fa"; // Import the icon

// Navbar Component
const TestNav = () => {
  const [showCreatorsMenu, setShowCreatorsMenu] = useState(false);
  const [showMediaCompaniesMenu, setShowMediaCompaniesMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <NavbarWrapper>
      <NavbarContainer>
        <Logo>JELLYSMACK</Logo>
        <Hamburger onClick={() => setShowMobileMenu(!showMobileMenu)}>
          &#9776;
        </Hamburger>
        <NavLinks showMobileMenu={showMobileMenu}>
          <NavLink
            href="#"
            onMouseEnter={() => setShowCreatorsMenu(true)}
            onMouseLeave={() => setShowCreatorsMenu(false)}
          >
            FOR CREATORS
            <IconWrapper>
              <FaChevronDown />
            </IconWrapper>
            {showCreatorsMenu && (
              <DropdownMenu>
                <DropdownItem href="#">Creator Program</DropdownItem>
              </DropdownMenu>
            )}
          </NavLink>

          <NavLink
            href="#"
            onMouseEnter={() => setShowMediaCompaniesMenu(true)}
            onMouseLeave={() => setShowMediaCompaniesMenu(false)}
          >
            FOR MEDIA COMPANIES
            <IconWrapper>
              <FaChevronDown />
            </IconWrapper>
            {showMediaCompaniesMenu && (
              <DropdownMenu>
                <DropdownItem href="#">Media Solutions</DropdownItem>
                <Divider />
                <DropdownItem href="#">Advertising Services</DropdownItem>
              </DropdownMenu>
            )}
          </NavLink>

          <NavLink href="#">FOR BRANDS</NavLink>
          <NavLink href="#">ORIGINALS</NavLink>
          <NavLink href="#">CAREERS</NavLink>
          <NavLink href="#">BLOG</NavLink>
          <GetInTouchWrapper>
            <GetInTouchButton href="#">GET IN TOUCH</GetInTouchButton>
          </GetInTouchWrapper>
        </NavLinks>
      </NavbarContainer>
    </NavbarWrapper>
  );
};

// Styled Components
const NavbarWrapper = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 6em;
  margin-bottom: 4em;
  padding: 2px;
  border-radius: 30px;
  background: linear-gradient(to right, #ff00ff, #00ff00);
`;

const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background-color: black;
  color: white;
  border-radius: 30px;
  position: relative;

  @media (max-width: 768px) {
    padding: 15px 20px;
  }
`;

const Logo = styled.h1`
  font-size: 1.2em;
  font-weight: bold;
  cursor: pointer;
`;

const Hamburger = styled.div`
  display: none;
  font-size: 1.5em;
  cursor: pointer;
  color: white;

  @media (max-width: 1400px) {
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;

  @media (max-width: 1400px) {
    flex-direction: column;
    background-color: black;
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    padding: 10px;
    border-radius: 0 0 30px 30px;
    display: ${(props) => (props.showMobileMenu ? "flex" : "none")};
  }
`;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 0.9em;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.8em;
`;

const GetInTouchWrapper = styled.div`
  margin-left: 20px; /* Adds space between the last menu and the button */
`;

const GetInTouchButton = styled.a`
  color: #00ff00;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: #00ff00;
    text-decoration: underline;
  }

  @media (max-width: 1400px) {
    align-self: flex-start;
  }
`;

// Dropdown Menu Styles
const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #333;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  min-width: 180px;
  z-index: 10;

  @media (max-width: 1400px) {
    position: static;
    box-shadow: none;
    padding: 0;
    border-radius: 0;
  }
`;

const DropdownItem = styled.a`
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  font-size: 0.9em;
  cursor: pointer;

  &:hover {
    background-color: #444;
  }
`;

// Divider for the second menu
const Divider = styled.div`
  height: 2px;
  width: 80%;
  background: linear-gradient(to right, #ff00ff, #00ff00);
  margin: 5px auto;
`;

export default TestNav;
